import React from 'react'
import i18next from 'i18next'
import { Link } from '../../../../utils/link'
import { GenericPageHeader } from '../../../sharedLayout/pageheader'

type SpecialistPageHeaderProps = {
  breadcrumbs: { url: string; title: string }[]
  title: string
  intro?: string
  role?: string
}

export const SpecialistPageHeader = (props: SpecialistPageHeaderProps) => (
  <GenericPageHeader
    kind="specialistDetail"
    breadcrumbs={props.breadcrumbs}
    title={props.title}
    intro={props.intro}
    extraJSXBelowTitle={<p className="pageheader__label">{props.role}</p>}
  />
)

type SpecialistPageStudyProps = {
  study?: string
  areasOfFocus?: string
  auxiliaryFunctions?: string
  BIGRegistrationNumber?: string
}

export const SpecialistPageCVLayout = (props: SpecialistPageStudyProps) => (
  <>
    {props.study && (
      <section className="block--study block--wysiwyg container--m gutter--m">
        <div className="block__inner">
          <div className="block__content section--bg-secondary">
            <header className="block__header">
              <h2 className="block__title title--l">{i18next.t('misc:background')}</h2>
            </header>
            <ul className="block__list typo--xs">
              {props.study && (
                <li key="study" className="block__item">
                  <h3 className="block__subtitle title--m">{i18next.t('misc:study')}</h3>
                  <div dangerouslySetInnerHTML={{ __html: props.study }} className="text--styled" />
                </li>
              )}
              {props.areasOfFocus && (
                <li key="areaOfFocus" className="block__item">
                  <h3 className="block__subtitle title--m">{i18next.t('misc:areaOfFocus')}</h3>
                  <div dangerouslySetInnerHTML={{ __html: props.areasOfFocus }} className="text--styled" />
                </li>
              )}
              {props.auxiliaryFunctions && (
                <li key="auxiliaryFunctions" className="block__item">
                  <h3 className="block__subtitle title--m">{i18next.t('misc:auxiliaryFunctions')}</h3>
                  <div dangerouslySetInnerHTML={{ __html: props.auxiliaryFunctions }} className="text--styled" />
                </li>
              )}
              {props.BIGRegistrationNumber && (
                <li key="bIGRegistrationNumber" className="block__item">
                  <h3 className="block__subtitle title--m">{i18next.t('misc:bigRegistrationNumber')}</h3>
                  <p>{props.BIGRegistrationNumber}</p>
                </li>
              )}
            </ul>
          </div>
        </div>
      </section>
    )}
  </>
)

type SpecialistPageButtonProps = {
  buttons: { title: string; url: string }[]
}

export const SpecialistPageButtonLayout = (props: SpecialistPageButtonProps) => (
  <section className="block--button container--m gutter--m">
    <div className="block__inner">
      <div className="block__content block__clickables">
        {props.buttons.length > 0 ? (
          props.buttons.map((department) => (
            <div className="block__clickable">
              <Link url={department.url} className="block__button button--primary" key={department.title}>
                <span className="button__label">
                  {i18next.t('misc:allSpecialistsWith', { department: department.title })}
                </span>
              </Link>
            </div>
          ))
        ) : (
          <div className="block__clickable">
            <Link url="/specialisten" className="block__button button--primary">
              <span className="button__label">{i18next.t('misc:allSpecialists')}</span>
            </Link>
          </div>
        )}
      </div>
    </div>
  </section>
)
